function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.00011 0.0161133C3.59211 0.0161133 0.0161133 3.59211 0.0161133 8.00011C0.0161133 12.4081 3.59211 15.9841 8.00011 15.9841C12.4081 15.9841 15.9841 12.4081 15.9841 8.00011C15.9841 3.59211 12.4081 0.0161133 8.00011 0.0161133ZM8.00011 14.3841C4.48011 14.3841 1.61611 11.5201 1.61611 8.00011C1.61611 4.48011 4.48011 1.61611 8.00011 1.61611C11.5201 1.61611 14.3841 4.48011 14.3841 8.00011C14.3841 11.5201 11.5201 14.3841 8.00011 14.3841ZM5.00012 9.20012L8.60012 2.40012V6.80012H11.0001L7.51212 13.6001V9.20012H5.00012Z",
  fill: "white"
});

var SvgOfflineBolt16 = function SvgOfflineBolt16(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOfflineBolt16, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/offline_bolt_16.a3399cb8.svg";
export { ForwardRef as ReactComponent };